import { useAutoneTranslation } from '@autone/translations';
import {
  createColumnLoadingGuards,
  DataTableCellContent,
  DataTableCellTitle,
  DataTableIntegerValue,
  type DataTableLoadingObject,
} from '@autone/ui';
import { type ColumnHelper } from '@tanstack/react-table';

import { type APP_NAME } from '../../../../consts';

const COLUMN_ID = 'locations_assorted' as const;

export type LocationsAssortedColumnId = typeof COLUMN_ID;

interface LocationsAssortedFields {
  assorted_locations_count: number;
}

const { columnCellGuard, accessorFnGuard } =
  createColumnLoadingGuards<LocationsAssortedFields>();

export const createLocationsAssortedColumn = <
  T extends LocationsAssortedFields | DataTableLoadingObject,
>(
  columnHelper: ColumnHelper<T>,
) =>
  columnHelper.accessor(
    accessorFnGuard((row) => row.assorted_locations_count),
    {
      id: COLUMN_ID,
      size: 150,
      header: function StoresAssortedHeader() {
        const { t } = useAutoneTranslation<typeof APP_NAME>();
        return (
          <DataTableCellContent align={'right'}>
            <DataTableCellTitle className="uppercase font-medium">
              {t('table-columns.locations-assorted')}
            </DataTableCellTitle>
          </DataTableCellContent>
        );
      },
      cell: (ctx) =>
        columnCellGuard({
          ctx,
          renderCell: function StoresAssortedCell({ getValue }) {
            return (
              <DataTableCellContent align={'right'}>
                <DataTableCellTitle>
                  <DataTableIntegerValue value={getValue()} />
                </DataTableCellTitle>
              </DataTableCellContent>
            );
          },
        }),
    },
  );
